export default "__VITE_ASSET__D5_I0Trk__"